/* jshint esversion: 6 */
/* jshint ignore:start */
import { useContext, useRef, useState } from 'react';
import { getCountries, getCountryCallingCode } from "react-phone-number-input";
import { MyContext } from '../Context/MyProvider';
import { showToast } from '../showTost';
import axios from 'axios';
import Usericon from '../assets/Icon/user.svg';
import Emailicon from '../assets/Icon/email.svg';
import Callicon from '../assets/Icon/call.svg';
import Lockicon from '../assets/Icon/lock.svg';
import Eyeicon from '../assets/Icon/eye.svg';
import Eyeslashicon from '../assets/Icon/eye-slash.svg';
import { LuUsers } from "react-icons/lu";
import { useTranslation } from 'react-i18next';
import secureLocalStorage from "react-secure-storage";
const Signup = () => {

    const { t } = useTranslation();
    const { setIsLoginShow, setIsSignUpShow, ApiBaseUrl, setIsLogin } = useContext(MyContext);

    const [value, setValue] = useState();
    const [passType, setPassType] = useState("Password");
    const [signUpData, setSignUpData] = useState({
        name: "",
        email: "",
        password: "",
        referral: ""
    });
    const [isOtpShow, setIsOtpShow] = useState(false);
    const [otpFiled, setOtpFiled] = useState(Array(6).fill(''));
    const [sendOtp, setSendOtp] = useState("");
    const [apiloading, setApiLoading] = useState(false);
    const [showCcode, setShowCcode] = useState(false);
    const [searchCcode, setSearchCcode] = useState("");
    const [selectCcode, setSelectCcode] = useState("+91");

    const OtpRef = useRef(Array.from({ length: 6 }, () => null));

    const countries = getCountries();
    const FilterCCode = countries.filter((item) => getCountryCallingCode(item).toString().includes(searchCcode));

    const handelCheck = () => {
        const emailValidation = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

        if (apiloading) {
            return;
        }

        if (!signUpData.name || !signUpData.email || !value || !signUpData.password) {
            showToast({ title: t("Please Enter Details"), id: "warning" });
            return;
        }

        if (!emailValidation.test(signUpData.email)) {
            showToast({ title: t("Please Enter a Valid Email"), id: "warning" });
            return;
        }

        setApiLoading(true);

        const Data = {
            phone: value,
            ccode: selectCcode,
            email: signUpData?.email
        };

        axios.post(`${ApiBaseUrl}/customer/mobile_check`, Data)
            .then((res) => {
                // console.log("mobile_check", res);
                const { ResponseCode, message, Result, email_result } = res.data;
                if (ResponseCode === 200) {

                    if (!Result) {
                        showToast({ title: message, id: "error" });
                        setApiLoading(false);
                        return;
                    }
                    if (!email_result) {
                        showToast({ title: message, id: "error" });
                        setApiLoading(false);
                        return;
                    }

                    axios.get(`${ApiBaseUrl}/customer/otp_detail`)
                        .then((res) => {
                            // console.log("otp_detail", res);
                            const { ResponseCode, message } = res.data;
                            if (ResponseCode === 200) {
                                if (message === "MSG91") {
                                    handleMSG91(Data);
                                } else if (message === "Twilio") {
                                    handleTwilio(Data);
                                } else {
                                    handleSignUp();
                                }
                            }
                        });

                } else {
                    showToast({ title: message, id: "error" });
                    setApiLoading(false);
                }
            })
            .catch((error) => {
                console.error(error);
            });
    };

    const handleMSG91 = (data) => {
        axios.post(`${ApiBaseUrl}/customer/msg91`, data)
            .then((res) => {
                // console.log("msg91", res);
                setApiLoading(false);
                const { ResponseCode, message, otp } = res.data;
                if (ResponseCode === 200) {
                    showToast({ title: message, id: "success" });
                    setIsOtpShow(true);
                    setSendOtp(otp);
                }
            });
    };

    const handleTwilio = (data) => {
        axios.post(`${ApiBaseUrl}customer/twilio`, data)
            .then((res) => {
                // console.log("twilio", res);
                setApiLoading(false);
                const { ResponseCode, message, otp } = res.data;
                if (ResponseCode === 200) {
                    showToast({ title: message, id: "success" });
                    setIsOtpShow(true);
                    setSendOtp(otp);
                }
            });
    };

    const handleChange = (index, value) => {
        const Otp = [...otpFiled];
        Otp[index] = value;
        setOtpFiled(Otp);
        if (value && !isNaN(value) && index < OtpRef.current.length - 1) {
            OtpRef.current[index + 1].focus();
        }
    };

    const InputHandle = (index, e) => {
        if (e.key === "Backspace" && index > 0 && !e.target.value) {
            OtpRef.current[index - 1].focus();
        }
    };

    const HandelVerifyOtp = () => {
        if (sendOtp === otpFiled.join("")) {
            handleSignUp();
        } else {
            showToast({ title: t("OTP is invalid !!"), id: "error" });
        }
    };

    const handleSignUp = () => {

        setApiLoading(true);

        const Data = {
            Name: signUpData.name,
            Email: signUpData.email,
            phone: value,
            ccode: selectCcode,
            Password: signUpData.password,
            referral_code: signUpData.referral ? signUpData.referral : ""
        };

        axios.post(`${ApiBaseUrl}/customer/signup`, Data)
            .then((res) => {
                // console.log(res);
                const { ResponseCode, customer, message } = res.data;
                if (ResponseCode === 200) {
                    showToast({ title: message, id: "success" });
                    secureLocalStorage.setItem("Loginuser", JSON.stringify(customer));
                    secureLocalStorage.setItem("Userid", customer.id);
                    setIsLogin("123");
                    setIsSignUpShow(false);
                } else {
                    showToast({ title: message, id: "error" });
                }
                setApiLoading(false);
            })
            .catch((error) => {
                console.error(error);
            });
    };

    const handleSelectCuntryCode = async (item) => {
        setSelectCcode(`+${getCountryCallingCode(item)}`);
        setShowCcode(false);
    }

    return (
        <div className='signup-box'>
            {isOtpShow
                ? <div className="py-[10px] px-[20px]">
                    <h1 className='text-center text-[24px] font-[500]'>Almost there!</h1>
                    <p className='text-center text-gray-500 text-[18px] leading-[25px]'>You need to enter 6-digit code that we have send to your mobile number <span className='text-black text-[16px] font-[500]'>{value}</span></p>
                    <h1 className='text-center'>Your OTP : {sendOtp && sendOtp}</h1>
                    <div className="flex items-center gap-[20px] mt-[10px]">
                        {otpFiled.map((value, index) => {
                            return <input type="number"
                                ref={(e) => (OtpRef.current[index] = e)}
                                key={index}
                                value={value}
                                className='otp-box focus-within:outline-[#4038FF]'
                                maxLength="1"
                                onChange={(e) => handleChange(index, e.target.value)}
                                onKeyDown={(e) => InputHandle(index, e)}
                            />
                        })}
                    </div>
                    <button onClick={HandelVerifyOtp} className='w-[100%] bg-[#4038FF] text-white py-[8px] mt-[20px] font-[500] rounded-[10px]'>
                        {apiloading
                            ? <div className="loader mx-auto"></div>
                            : <span>VERIFY OTP</span>}
                    </button>
                </div>
                : <div className="py-[10px] px-[20px]">
                    <h1 className="text-[24px] font-[500]">Sign Up</h1>
                    <div className="login-input focus-within:border-[#4038FF] mt-[20px] focus-within:border-[1px]">
                        <img src={Usericon} alt="userIcon" className="w-[25px]" />
                        <input onChange={(e) => setSignUpData({ ...signUpData, name: e.target.value })} type="text" placeholder='Full Name' className='w-[100%] bg-transparent outline-none px-[10px]' />
                    </div>
                    <div className="login-input focus-within:border-[#4038FF] mt-[20px] focus-within:border-[1px]">
                        <img src={Emailicon} alt="EmailIcon" className="w-[25px]" />
                        <input onChange={(e) => setSignUpData({ ...signUpData, email: e.target.value })} type="text" placeholder='Email' className='w-[100%] bg-transparent outline-none px-[10px]' />
                    </div>
                    <div className="relative gap-[5px] login-input focus-within:border-[#4038FF] mt-[20px] focus-within:border-[1px]">
                        <img src={Callicon} alt="Call Icon" className="w-[25px]" />
                        <div className="flex items-center gap-4">
                            <div onClick={() => setShowCcode(!showCcode)} className="flex items-center border">
                                <svg width="20" height="20" className="cursor-pointer" viewBox="0 0 24 24" fill="none" xmlns="http:www.w3.org/2000/svg">
                                    <path d="M12 14.75C11.808 14.75 11.616 14.6771 11.47 14.5301L7.46999 10.5301C7.17699 10.2371 7.17699 9.76202 7.46999 9.46902C7.76299 9.17602 8.23803 9.17602 8.53103 9.46902L12.001 12.939L15.471 9.46902C15.764 9.17602 16.239 9.17602 16.532 9.46902C16.825 9.76202 16.825 10.2371 16.532 10.5301L12.532 14.5301C12.384 14.6771 12.192 14.75 12 14.75Z" fill="#25314C" />
                                </svg>
                                <h1 className="me-1">{selectCcode}</h1>
                            </div>
                        </div>
                        <input type="tel" value={value} onChange={(e) => setValue(e.target.value)} className='w-[100%] bg-transparent outline-none px-[10px]' placeholder='Enter your number' />
                        {showCcode && <div className="absolute z-[666]">
                            <div className="w-[100px] bg-white border border-gray-400">
                                <input type="number" value={searchCcode} onChange={(e) => setSearchCcode(e.target.value)} className="w-full px-[10px] py-[2px] outline-none border-b" placeholder="Search" />
                                <ul className="max-h-[200px] scroll-container">
                                    {FilterCCode.map((item, index) => {
                                        return <li key={index} onClick={() => handleSelectCuntryCode(item)} className="px-[10px] py-[2px] cursor-pointer hover:bg-gray-200">+{getCountryCallingCode(item)}</li>
                                    })}
                                </ul>
                            </div>
                        </div>}
                    </div>
                    <div className="login-input focus-within:border-[#4038FF] mt-[20px] focus-within:border-[1px]">
                        <img src={Lockicon} alt="userIcon" className="w-[25px]" />
                        <input onChange={(e) => setSignUpData({ ...signUpData, password: e.target.value })} className="bg-transparent px-[10px] w-[100%] outline-none" type={passType} placeholder="Passowrd" />
                        <img onClick={() => passType === "text" ? setPassType("Password") : setPassType("text")} src={passType === "text" ? Eyeicon : Eyeslashicon} alt="LockIcon " className="w-[20px] cursor-pointer" />
                    </div>
                    <div className="login-input focus-within:border-[#4038FF] mt-[20px] focus-within:border-[1px]">
                        <LuUsers className='text-[20px] text-[#383e4b]' />
                        <input onChange={(e) => setSignUpData({ ...signUpData, referral: e.target.value })} type="text" placeholder='Referral Code (Optional)' className='w-[100%] bg-transparent outline-none px-[10px]' />
                    </div>
                    <h1 className="mt-[10px] font-[500]">By signing up, you agree to our <span className="text-[#4038FF]">Terms of Service</span> and <span className="text-[#4038FF]">Privacy Policy.</span></h1>
                    <button onClick={handelCheck} className='bg-[#4038FF] w-[100%] py-[8px] text-white font-bold rounded-[10px] mt-[20px]'>
                        {apiloading
                            ? <div className="loader mx-auto"></div>
                            : <span>Sign Up</span>}
                    </button>
                    <h1 className='mt-[10px] text-center font-[500]'>Already have and account? <span onClick={() => { setIsLoginShow(true); setIsSignUpShow(false) }} className='text-[#4038FF] cursor-pointer'>Sign In</span> </h1>
                </div>}
        </div>
    )
}

export default Signup
/* jshint ignore:end */